import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from "react";
import { FileType, isNetworkConnected, PlaybackEvent, PlaybackEventEmitter, PlaybackState, useAuthStateStore, usePlaybackStateStore, usePlaylistStateStore, } from "@annunciate/core";
import { getContentProgress, syncProgress } from "@annunciate/query";
import { pausePlayers } from "../player";
export const useResumeContent = () => {
    const hasAuthInitialized = useAuthStateStore((state) => state.hasAuthInitialized);
    const client = useQueryClient();
    useEffect(() => {
        const { content, getState } = usePlaybackStateStore.getState();
        if (!content)
            return;
        const states = {};
        const contentId = content.id.toString();
        if (getState(contentId) === PlaybackState.NONE) {
            usePlaybackStateStore.setState({ content: null });
        }
        else {
            states[contentId] = PlaybackState.STOPPED;
        }
        usePlaybackStateStore.setState({
            states,
            initialPosition: undefined,
            isPlaying: false,
            restartAttempts: 0,
            playerIndex: usePlaybackStateStore.getState().getInitialPlayerIndex(),
        });
        usePlaylistStateStore.setState({
            sessionId: undefined,
        });
    }, []);
    useEffect(() => {
        const content = usePlaybackStateStore.getState().content;
        if (!content ||
            !hasAuthInitialized ||
            !client) {
            return;
        }
        const restart = async () => {
            await pausePlayers({ content });
            try {
                await syncProgress(client);
            }
            catch (error) {
                console.error("error syncing progress", error);
            }
            const progress = getContentProgress(client, content.id);
            if (content.asset?.type === FileType.AUDIO) {
                await PlaybackEventEmitter.emit(PlaybackEvent.RESTART, progress?.position);
            }
            else {
                await PlaybackEventEmitter.emit(PlaybackEvent.RESTART);
            }
        };
        const isAuthValid = useAuthStateStore.getState().isAuthValid();
        if (!isAuthValid) {
            const restartIfOffline = async () => {
                const isConnected = await isNetworkConnected();
                const currentHasAuthInit = useAuthStateStore.getState().hasAuthInitialized;
                if (isConnected || !currentHasAuthInit) {
                    await pausePlayers({ content });
                    return;
                }
                restart();
            };
            restartIfOffline();
            return;
        }
        restart();
    }, [hasAuthInitialized, !!client]);
};
//# sourceMappingURL=useResumeContent.js.map